import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-change-project-checkin-start-date',
  templateUrl: './change-project-checkin-start-date.component.html',
  styleUrls: ['./change-project-checkin-start-date.component.scss']
})
export class ChangeProjectCheckinStartDateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
